import { ReactNode, useState } from "react";
import styles from "./SuccessPlanLayout.module.scss";
import { KeyboardDoubleArrowLeft } from "@mui/icons-material";

type SuccessPlanLayoutProps = {
  header: ReactNode;
  profile: ReactNode;
  sectionGroup: ReactNode;
};

const SuccessPlanLayout = ({ header, profile, sectionGroup }: SuccessPlanLayoutProps) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>{header}</div>
      <div className={styles.main}>
        <div className={`${styles["main-left"]} ${collapsed ? styles["main-left-collapsed"] : ""}`}>
          {profile}
        </div>
        <div className={styles["main-collapse"]}>
          <div
            className={`${styles["main-collapse-bar"]} ${collapsed ? styles["collapse-right"] : styles["collapse-left"]}`}
            onClick={handleCollapse}
          >
            <KeyboardDoubleArrowLeft
              style={{
                fontSize: "14px",
                color: "#878787",
                transform: `rotate(${collapsed ? 180 : 0}deg)`,
                transition: "transform 0.3s ease",
              }}
            />
          </div>
        </div>

        <div className={styles["main-right"]}>{sectionGroup}</div>
      </div>
    </div>
  );
};

export default SuccessPlanLayout;
